import { BaseMutations } from '@/store/base-mutations';
import { Reports } from '@/modules/reports/types';
import ReportsSalesState from './state';

export default class ReportsSalesMutations extends BaseMutations<ReportsSalesState> {
  SET_SALES(sales: Reports.SalesPlan[]) {
    this.state.sales = sales;
  }

  SET_YEARS(years: number[]) {
    this.state.years = years;
  }

  SET_TOTAL_PERCENT(total_percent: number) {
    this.state.total_percent = total_percent;
  }

  UPD_FILTER_VALUE({ quarter, year } : {quarter: number| null, year: number | null}) {
    this.state.filters.year = year;
    this.state.filters.quarter = quarter;
  }

  TOGGLE_LOADING(toggle: boolean) {
    this.state.loading = toggle;
  }
}
